import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import LocationList from '../../components/admin/locations/LocationList';
import LocationForm from '../../components/admin/locations/LocationForm';
import './AdminLocations.css';

const AdminLocations = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingLocation, setEditingLocation] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAdd = () => {
    setEditingLocation(null);
    setShowForm(true);
  };

  const handleEdit = (location) => {
    setEditingLocation(location);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingLocation(null);
  };

  const handleSave = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="admin-locations-page">
      <div className="admin-page-header">
        <h1 className="admin-page-title">Locations</h1>
        <button onClick={handleAdd} className="btn btn-primary">
          <Plus size={20} />
          Add Location
        </button>
      </div>

      <LocationList 
        key={refreshKey}
        onEdit={handleEdit} 
        onAdd={handleAdd}
      />

      {showForm && (
        <LocationForm
          location={editingLocation}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default AdminLocations;